import { useCustomerStore } from '../../../stores/customerStore';

/** Seiten, die Posten mehrerer Gesellschaften zusammen zeigen können. */
export function supportsAllCompaniesView(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '');
  return path === '/customer' || path.startsWith('/customer/dashboard') || path.startsWith('/customer/contracts');
}

/**
 * Welche Fristen das Portal abfragt. Wer mehrere Gesellschaften einer Firmengruppe sehen darf, bekommt
 * standardmäßig alle zusammen (Vorgabe Kevin, 11.09.2026). Umgeschaltet wird oben rechts im Kopf
 * (`PortalCompanySwitcher`): „Alle Gesellschaften" oder eine einzelne — dann nur die aktive.
 * Der Server liefert bei `all` nur Gesellschaften, bei denen der Bereich freigegeben ist.
 */
export function useDeadlineScope(): 'all' | 'single' {
  const companyCount = useCustomerStore((st) => st.contact?.companies?.length ?? 0);
  const allCompaniesView = useCustomerStore((st) => st.allCompaniesView);
  return companyCount > 1 && allCompaniesView ? 'all' : 'single';
}
